var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CustomPIXIComponent } from 'react-pixi-fiber';
import { AnimatedComplexSprite } from './animated-complex-sprite';
var extractFramesInfos = function (_a) {
    var animationPath = _a.animationPath, pingPong = _a.pingPong, flip = _a.flip, framesDurations = _a.framesDurations, framesOrder = _a.framesOrder;
    return ({
        animationPath: animationPath, pingPong: pingPong, flip: flip, framesDurations: framesDurations, framesOrder: framesOrder
    });
};
var getAnimatedComplexSpriteFromProps = function (_a) {
    var spritesheet = _a.spritesheet, ticker = _a.ticker, cache = _a.cache, rest = __rest(_a, ["spritesheet", "ticker", "cache"]);
    return new AnimatedComplexSprite(spritesheet, extractFramesInfos(rest), ticker, cache);
};
var applyAnimatedComplexSpriteProps = function (sprite, oldProps, newProps) {
    var onLoop = newProps.onLoop, onFrameChange = newProps.onFrameChange, run = newProps.run, keepTimeState = newProps.keepTimeState, outline = newProps.outline, rest = __rest(newProps, ["onLoop", "onFrameChange", "run", "keepTimeState", "outline"]);
    sprite.setFramesInfos(extractFramesInfos(rest), { keepTimeState: keepTimeState });
    sprite.setOutline(outline);
    if (run === false) {
        sprite.stop();
    }
    else {
        sprite.play();
    }
    sprite.onLoop = onLoop;
    sprite.onFrameChange = onFrameChange;
};
export var AnimatedComplexSpriteReact = CustomPIXIComponent({
    customDisplayObject: getAnimatedComplexSpriteFromProps,
    customApplyProps: function (sprite, oldProps, newProps) {
        applyAnimatedComplexSpriteProps(sprite, oldProps, newProps);
        this.applyDisplayObjectProps(oldProps, newProps);
    }
}, 'AnimatedComplexSprite');
